import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-modelvideo3',
  templateUrl: './modelvideo3.component.html',
  styleUrls: ['./modelvideo3.component.scss']
})
export class Modelvideo3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
